import { Route, Switch } from "react-router-dom";

import InflowComponent from "../../components/page/statistics/InflowComponent";
import SalesComponent from "../../components/page/statistics/SalesComponent";

const StatisticsPage = () => {
  return (
    <Switch>
      <Route path="/statistics/sales" component={SalesComponent} />
      <Route path="/statistics/inflow" component={InflowComponent} />
    </Switch>
  );
};

export default StatisticsPage;
